module.exports = __webpack_public_path__ + "static/ben_steinberg-8dd62ad1450ee00279bb24da51152076.jpeg";